import React, { Component } from "react";
import { connect } from 'react-redux';
import { getBargains } from './-global-state/actions/bargains';
import { getBargainCount } from "./-global-state/actions/bargains";
import Routes from './routing/routes';
import { verifyUser } from './-global-state/actions/user-actions';
import { getUserData } from './-global-state/actions/user-actions';

class App extends Component {
  componentDidMount = () => {
    this.props.getBargainCount();
    this.props.getBargains(localStorage.getItem("token"));
    this.props.verifyUser(localStorage.getItem("token"));
    this.props.getUserData(localStorage.getItem("token"));
  }
  render() {
    return ( 
      <Routes />
     );
  }
}

export default connect(null, { getBargains, verifyUser, getUserData, getBargainCount })(App);